/**
 * React DOM Entry Point
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './index.css';
import { registerServiceWorker } from '../cache/service-worker-manager';
import { initPerformanceMonitoring } from './utils/performance-monitor';
import { isProductionMode } from './utils/env';

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

// Initialize performance monitoring
initPerformanceMonitoring();

if (isProductionMode()) {
  registerServiceWorker();
}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
